// missedmap — 3회 오답 후 "내가 뭘 몰랐을까요?" 지식 맵의 응답 파서.
// AI 응답 한 줄 형식: "ITEM: 개념|라벨|한줄 설명". 종류가 개념/태도(영어 모드 concept/attitude)가
// 아니거나 형식을 어긴 줄은 조용히 버리고, 최대 6개까지만 받는다(스펙 3~6개의 상한).
const KIND_ALIAS={ "개념":"개념", "태도":"태도", concept:"개념", attitude:"태도" };

function parseMissedItems(txt){
  const out=[];
  for(const line of String(txt||"").split("\n")){
    const m=/^\s*ITEM\s*:\s*([^|]+?)\s*\|\s*([^|]+?)\s*(?:\|(.*))?$/.exec(line);
    if(!m)continue;
    const kind=KIND_ALIAS[m[1].toLowerCase()]||KIND_ALIAS[m[1]];
    if(!kind)continue;
    out.push({kind,label:m[2].trim(),desc:(m[3]||"").trim()});
    if(out.length>=6)break;
  }
  return out;
}

export { parseMissedItems };
